<script>
import ChannelMixin from "./channel-mixin"
import ChannelPostMenu from "./channel-post-menu.vue"

export default {
  name: 'ChannelPrivate',
  mixins: [ChannelMixin],
  components: {ChannelPostMenu},
  props: {
    navRelative: {type: Boolean, default: false},
    showTitle: {type: Boolean, default: false},
  },
  data() {
    return {
      userId: this.$storage.get('mm_user_id', {}),
      otherUser: {},
    }
  },

  watch: {
    users: {
      handler(newValue) {
        if (Object.keys(newValue).length)
          this.otherUser = Object.values(newValue).filter(user => user.id != this.userId)[0]
      },
    },
  },

  computed: {
    otherUserDisplay() {
      return `${this.otherUser.first_name || ''} ${this.otherUser.last_name || ''}`.trim() || this.otherUser.username
    }
  },

  mounted() {
    let query = {...this.$route.query}
    if ('reply_to_post_id' in query) {
      let me = this
      this.$mattermost.get(`/posts/${query.reply_to_post_id}`).then(response => {

        delete query.reply_to_post_id
        try {
          this.$router.push({query: query})
        } catch (error) { console.error(error) }
        let post = response.data

        me.$mattermost.get(`/users/${post.user_id}`).then(response => {
          let username = response.data.username
          me.postInput = me.formatReply(username, post.message)
          if ('message' in query) {
            me.postInput += `\n${query.message}`
          }
          me.$refs.postInput.focus()
        })
      })
    } else if ('message' in query) {
      this.postInput = query.message
      this.$refs.postInput.focus()
    }
  },

  methods: {
    pushMessage(data) {
      const payload = {
        'recipient_email': this.otherUser.email,
        'title': `${this.$storage.user.username}`,
        'body': data.data.message,
        'url': window.location.href,
      }
      console.log('pushMessage()', data, payload)
      this.$api.post('zpcard/push-notify/', payload)
    },

    postMessage() {
      // overrides channel-mixin.postMessage() to create a pushMessage to user
      console.log('channel-private.postMessage()')
      let me = this
      if (this.postEditId) {
        this.putPost(this.postEditId).then(response => {
          me.pushMessage(response)
        })
      } else {
        this.createPost().then(response => {
          me.pushMessage(response)
        })
      }
    },

    getEndTime(startTime, mins) {
      // startTime, e.g. '10:30'
      let date = new Date()
      const [hh, mm] = startTime.split(':').map(Number)
      date.setUTCHours(hh, mm + mins, 0, 0)
      return date.toISOString().slice(11,16)
    },

    getCalendarData(post) {
      // gets the calendar data if appointment request
      // `:calendar: Bitte um Termin am: **${i.date}**\n**${i.time} Uhr** zum Thema: **${i.subject}**`
      let calData = null

      // strip lines starting with />/
      const lines = post.message.split('\n')
      const filteredLines = lines.filter(line => !line.trim().startsWith('>'))
      const message = filteredLines.join('\n')

      const dateMatch = message.match(/[ *](\d{4}-\d{2}-\d{2})[ *]/);
      const timeMatch = message.match(/[ *](\d{2}:\d{2})[ *]/);
      const subjectMatch = message.match(/Thema: [ *]+(\w+)[ *]/);

      if (dateMatch && timeMatch && subjectMatch) {
        let startTime = timeMatch[1] // "10:00"
        calData = {
          date: dateMatch[1], // "2024-08-31"
          startTime: startTime,
          endTime: this.getEndTime(startTime, 30),
          subject: subjectMatch[1] + ` (${this.otherUserDisplay})`, // "Kennenlernen (Max Muster)"
          description: post.message
        }
        console.log('calData: ', calData)
      }
      return calData
    }
  }
}
</script>

<template>
<div>
  <h3 v-if="showTitle" class="text-end">{{ otherUserDisplay }}</h3>
  <div class="card">
    <div class="card-body d-flex flex-column" :class="{'pb-5': navRelative}">

      <div :class="{'c-chat-content': navRelative, 'c-overflow-y': navRelative}">
        <div v-if="prevPostId" class="text-center">
          <span class="btn" @click.prevent="fetchOlderPosts">
            <i class="fas fa-chevron-up"></i>
          </span>
        </div>

        <span v-if="orderedPostIds.length">
          <div v-for="pid in orderedPostIds" :key="pid" class="mb-2">

            <div class="d-flex">
              <channel-post-menu
              v-if="posts[pid].showMenu"
              :post="posts[pid]"
              :direct="true"
              :calendarData="getCalendarData(posts[pid])"
              @like="reactToPost($event, 'heart')"
              @thumbsup="reactToPost($event, '+1')"
              @reply="replyToPost($event)"
              @edit="editPost($event)"
              @delete="deletePost($event)"
              />

              <div
              class="card c-fit" :class="{ 'right-post': posts[pid].user_id == userId }"
              @click="onPostClick(pid, $event)"
              >
                <div class="c-post card-body p-2" v-html="convert2Html(posts[pid].message)">
                </div>
              </div>

            </div>

            <span v-if="pid in postReactions" class="c-reaction"
            :class="{ 'float-end': posts[pid].user_id == userId }"
            >
              <button v-for="(v, k) in postReactions[pid]" :key="k" class="btn btn-sm btn-outline-light me-1"
                @click.prevent="reactToPost(pid, k)"
              >
                <span style="color: black">{{ emojis[k] || k }}&nbsp;{{ v.size }}</span>
              </button>
            </span>

          </div>
        </span>
        <div v-else class="text-center">
          -- keine Nachrichten --
        </div>
      </div>

    </div>

    <div :class="{'c-navbar': navRelative, 'fixed-bottom': !navRelative}">
      <nav class="nav navbar navbar-light bg-light">
        <form style="width:100%">
            <div class="input-group">
                <textarea ref="postInput" class="form-control"
                  v-model="postInput"
                  @keydown.shift.enter.prevent="postMessage"
                  @keydown.ctrl.enter.prevent="postMessage"
                  :rows="currentRows"
                ></textarea>
                <button class="btn" @click.prevent="postMessage">
                    <span class="far fa-paper-plane"></span>
                </button>
            </div>
        </form>
      </nav>
    </div>

  </div>
</div>
</template>

<style scoped>
.c-navbar {
  flex-shrink: 0; /* Prevents navbar from growing */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.c-overflow-y {
    overflow-y: auto;
    scroll-behavior: smooth;
}
.c-fit {
    max-width:90%;
    display: inline-block;
    border-radius: .5rem;
}
.right-post {
    background-color: lemonchiffon;
    margin-left: auto;
}

.c-chat-content {
  height: 60vh;
  overflow-y: auto;
  padding-bottom: 2rem;
}
</style>